<template>
  <form id="form-confirmation" class="position-relative">
    <div class="vuedl-layout__closeBtn" @click="close(false)">
      ×
    </div>
    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        {{ title }}
      </v-card-title>

      <v-card-text class="py-1">
        {{ message }}
      </v-card-text>

      <v-divider class="my-2"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="confirm">Подтвердить</v-btn>
        <v-btn @click="close(false)">Отменить</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
export default {
  name: "ConfirmationModal",

  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },

  methods: {
    confirm() {
      this.$emit("submit", true);
    },
    close(isConfirmed) {
      this.$emit("submit", isConfirmed);
    },
  },
};
</script>
